exports = module.exports = require("../node_modules/.0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container{width:1140px;margin:0 auto}.main{margin-top:40px}@media (max-width:1140px){.container,.page-container{width:100%}}@media (max-width:768px){.container,.page-container{padding:0 20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.26.4@css-loader?minimize!./~/.10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-49a0b90e!./~/.10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 43
// module chunks = 1